import React from 'react'
import { Helmet } from 'react-helmet-async'

interface GoogleAnalyticsProps {
  trackingId?: string
  gtmId?: string
}

const GoogleAnalytics: React.FC<GoogleAnalyticsProps> = ({ 
  trackingId = 'G-XSVE1036D6', // ID real do Google Analytics 4
  gtmId // Google Tag Manager (opcional)
}) => {
  // Só carregar em produção E no host de produção (apex ou www).
  // Staging (*.amplifyapp.com) e preview nunca disparam GA4 (ADR-005 / docs/RELEASE.md).
  const isProduction =
    import.meta.env.PROD &&
    typeof window !== 'undefined' &&
    /(^|\.)zentriz\.com\.br$/.test(window.location.hostname)

  if (!isProduction) {
    return null
  }

  return (
    <Helmet>
      {/* Google Analytics 4 */}
      {trackingId && (
        <>
          <script async src={`https://www.googletagmanager.com/gtag/js?id=${trackingId}`} />
          <script>
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${trackingId}', {
                page_title: document.title,
                page_location: window.location.href,
                send_page_view: true,
                // Configurações adicionais para SEO
                custom_map: {
                  'custom_parameter_1': 'page_category',
                  'custom_parameter_2': 'service_type'
                }
              });
            `}
          </script>
        </>
      )}

      {/* Google Tag Manager - Apenas se gtmId for fornecido */}
      {gtmId && (
        <>
          <script>
            {`
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${gtmId}');
            `}
          </script>
          <noscript>
            {`<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`}
          </noscript>
        </>
      )}
    </Helmet>
  )
}

export default GoogleAnalytics
